// extracted by mini-css-extract-plugin
export default {"content":"BaseModal_content__D+3Jl","dark":"BaseModal_dark__TFZi1","header":"BaseModal_header__rIsj4","body":"BaseModal_body__qCXli","footer":"BaseModal_footer__oZC+w"};